module.exports = __webpack_public_path__ + "static/media/arab_turkey.015ad128.png";